/** Resolved URL for the AgedCareWise symbol (from Gemini Logo Image Final.png). */
export const agedCareWiseMarkUrl = new URL('../../assets/branding/agedcarewise-mark.png', import.meta.url).href;
